import makeStyles from "@material-ui/core/styles/makeStyles";
import {
  maxContentWidth,
  smMobileMinWidth,
  lgMobileMinWidth,
  tabletMinWidth,
  desktopMinWidth
} from "./helpers/constants";

export const PRIMARY_COLLUMN_CLASS = "primary-collumn";
export const COMPETING_COLUMNS_CLASS = "static-collumn";
export const DYNAMIC_COLUMN_CLASS = "dropdown-input-collumn";
export const CELL_DIVIDER_CLASS = "cell-divider";
export const HIGHLIGHT_CLASS = "highlight";

function CompareTableStyles(theme) {
  return makeStyles((theme) => ({
    root: {
      [`& .${COMPETING_COLUMNS_CLASS}`]: {
        display: "none"
      },
      [`& .${DYNAMIC_COLUMN_CLASS}`]: {
        display: "table-cell"
      },
      borderCollapse: "collapse",
      width: "100%",
      tableLayout: "fixed",
      // Column
      "& tr td, & thead tr th:not(:first-child)": {
        borderLeft: "4px solid",
        borderRight: "0px",
        borderLeftColor: theme.palette.background.default
      },
      // All Columns
      "& tr th:first-child": {
        border: "0px"
      },
      "& .color-chip": {
        height: "21px",
        width: "21px",
        marginLeft: "2px",
        marginRight: "2px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    },
    // Column Labels
    header: {
      // First Column
      [`& .${PRIMARY_COLLUMN_CLASS}`]: {},
      // Last Collumn
      [`& .${DYNAMIC_COLUMN_CLASS}`]: {
        "&:before": {
          background: theme.palette.CompareColorCode5
        }
      },
      ...theme.typography.caption,
      // All Columns
      "& tr th": {
        position: "relative",
        paddingBottom: "14px",
        fontWeight: "normal",
        "&:before": {
          bottom: 0,
          left: 0,
          right: 0,
          height: "8px",
          content: '""',
          position: "absolute"
        }
      },
      // First Column
      "& tr th:nth-child(2)": {
        boxSizing: "border-box",
        "&:before": {
          background: theme.palette.CompareColorCode1
        }
      },
      // Second Column
      "& tr th:nth-child(3)": {
        boxSizing: "border-box",
        "&:before": {
          background: theme.palette.CompareColorCode2
        }
      },
      // Third Column
      "& tr th:nth-child(4)": {
        boxSizing: "border-box",
        "&:before": {
          background: theme.palette.CompareColorCode3
        }
      },
      // Fourth Column
      "& tr th:nth-child(5)": {
        boxSizing: "border-box",
        "&:before": {
          background: theme.palette.CompareColorCode4
        }
      },
      // Fifth Column
      [`& .${DYNAMIC_COLUMN_CLASS}`]: {
        boxSizing: "border-box",
        "&:before": {
          background: theme.palette.CompareColorCode5
        }
      }
    },
    body: {
      "& .Large, & .large": {
        ...theme.typography.xsTableLarge
      },
      "& .Medium, & .medium": {
        ...theme.typography.xsTableMedium
      },
      "& .Regular, & .regular": {
        ...theme.typography.xsTableRegular
      },
      [`& .${HIGHLIGHT_CLASS}`]: {
        color: theme.palette.CompareHighlight,
        ...theme.typography.tableMedium,
        fontSize: "unset",
        "&, & > *": {
          fontFamily: '"Helvetica Neue LT W05_77 Bd Cn" !important',
          fontWeight: "normal !important"
        }
      },
      // Column
      ...theme.typography.body1,
      // Body Cell
      "& tr td": {
        backgroundColor: "white",
        padding: "16px 4px",
        textAlign: "center"
      },
      // Row Labels
      "& tr th .header": {
        ...theme.typography.caption,
        "& sup + sup": {
          marginLeft: "2px"
        },
        alignItems: "center",
        minHeight: "34px",
        boxSizing: "border-box",
        padding: "0px 0px 0px 0px",
        margin: "0px 0px 0px 0px",
        textAlign: "center"
      },
      "& td .cell-container": {
        position: "relative"
      },
      "& .divider-row": {
        height: "1px"
      },
      "& .divider-row th, & .divider-row td": {
        padding: 0
      },
      [`& .${CELL_DIVIDER_CLASS}`]: {
        width: "80%",
        height: "1px",
        display: "block",
        margin: "0 auto",
        background: theme.palette.background.default
      }
    },
    [`@media only screen and (min-width: ${smMobileMinWidth}px)`]: {
      header: {
        //Row Labels Column / Blank
        "& tr th:nth-child(1)": {
          boxSizing: "border-box",
          width: "70px",
          border: "0px"
        }
      }
    },
    [`@media only screen and (min-width: ${lgMobileMinWidth}px)`]: {
      body: {
        "& .Large, & .large": {
          ...theme.typography.smTableLarge
        },
        "& .Medium, & .medium": {
          ...theme.typography.smTableMedium
        },
        "& .Regular, & .regular": {
          ...theme.typography.smTableRegular
        }
      }
    },
    // Hide other columns in small screen size
    [`@media only screen and (min-width: ${tabletMinWidth}px)`]: {
      wrapper: {
        maxWidth: `${maxContentWidth}px`,
        marginLeft: "auto",
        marginRight: "auto"
      },
      root: {
        [`& .${COMPETING_COLUMNS_CLASS}`]: {
          display: "table-cell"
        },
        [`& .${DYNAMIC_COLUMN_CLASS}`]: {
          display: "none"
        },
        "& .sm": {
          display: "block"
        }
      },
      header: {
        ...theme.typography.mdCaption,
        //Row Labels Column / Blank
        "& tr th:nth-child(1)": {
          boxSizing: "border-box",
          width: "85px",
          border: "0px"
        },
        // First Column Label
        "& tr th:nth-child(2)": {
          boxSizing: "border-box"
        },
        // Second Column Label
        "& tr th:nth-child(3)": {
          boxSizing: "border-box"
        },
        // Third Column Label
        "& tr th:nth-child(4)": {
          boxSizing: "border-box"
        },
        // Fourth Column Label
        "& tr th:nth-child(5)": {
          boxSizing: "border-box"
        }
      },
      body: {
        "& tr th .header": {
          ...theme.typography.mdCaption
        },
        "& .Large, & .large": {
          ...theme.typography.mdTableLarge
        },
        "& .Medium, & .medium": {
          ...theme.typography.mdTableMedium
        },
        "& .Regular, & .regular": {
          ...theme.typography.mdTableRegular
        }
      }
    },
    [`@media only screen and (min-width: ${desktopMinWidth}px)`]: {
      header: {
        ...theme.typography.lgCaption,
        //Row Labels Column / Blank
        "& tr th:nth-child(1)": {
          boxSizing: "border-box",
          width: "85px",
          border: "0px"
        }
      },
      body: {
        "& tr th .header": {
          ...theme.typography.lgCaption
        },
        "& .Large, & .large": {
          ...theme.typography.lgTableLarge
        },
        "& .Medium, & .medium": {
          ...theme.typography.lgTableMedium
        },
        "& .Regular, & .regular": {
          ...theme.typography.lgTableRegular
        }
      }
    }
  }));
}

export default CompareTableStyles;
